import { useState, useEffect } from "react";

export const useExamTimer = (initialMinutes = 120) => {
    const [timeLeft, setTimeLeft] = useState(() => Math.max(0, (initialMinutes || 0) * 60));

    // reset when initialMinutes changes
    useEffect(() => {
        setTimeLeft(Math.max(0, (initialMinutes || 0) * 60));
    }, [initialMinutes]);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return { minutes, seconds, timeLeft, setTimeLeft };
};
